/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../redux/hooks';
import Tiles from '../../components/common/PortalTilesContainer/PortalTilesContainer';
import { useTranslation } from '../../components/common/Translation/translationProvider';
import { setPortalName, setPortalSecondaryHeader } from '../../redux/loginSlice';

const PageNotFound: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setPortalName(t('common.portalNamePageNotFound')));
    dispatch(setPortalSecondaryHeader(t('portalContainer.subHeader')));

    return () => {
      dispatch(setPortalSecondaryHeader(""));
    };
  }, [dispatch, t]);
  return (
    <Tiles />
  );
};

export default PageNotFound;